import { AfterViewInit, Directive, ElementRef, OnDestroy, Renderer2 } from '@angular/core';

/**
 * Hlavička panelu `nz-collapse` jde otevřít i z klávesnice (EL-2319).
 *
 * ng-zorro 17 dává hlavičce `role="button"`, ale ne `tabindex` ani klávesy — panel
 * (editor testu a kvízu, feedback, karta studenta) tak šel otevřít jen myší (nahlášeno
 * v EL-2293). Patří na každý `nz-collapse-panel` — výslovně, ať je ovládání z klávesnice
 * vidět v šabloně i v grepu (stejně jako `appKeyboardClick`):
 *
 * ```html
 * <nz-collapse-panel appCollapseKeyboard [nzHeader]="…">
 * ```
 *
 * Enter a mezerník vyvolají skutečný `click()` na hlavičce — přepnutí dál řídí ng-zorro,
 * včetně `nzActiveChange`. Zakázaný panel (`nzDisabled`) fokus nedostane.
 */
@Directive({
  selector: '[appCollapseKeyboard]',
  standalone: true,
})
export class CollapsePanelKeyboardDirective implements AfterViewInit, OnDestroy {

  private unlisten?: () => void;

  constructor(
    private elementRef: ElementRef<HTMLElement>,
    private renderer: Renderer2,
  ) { }

  ngAfterViewInit(): void {
    const host = this.elementRef.nativeElement;
    const header = host.querySelector<HTMLElement>('.ant-collapse-header');

    if (!header || host.classList.contains('ant-collapse-item-disabled')) {
      return;
    }

    this.renderer.setAttribute(header, 'tabindex', '0');
    this.unlisten = this.renderer.listen(header, 'keydown', (event: KeyboardEvent) => {
      // Jen klávesa na hlavičce samotné — tlačítko nebo pole v `nzExtra` si ji nechá.
      if ((event.key !== 'Enter' && event.key !== ' ') || event.target !== header || event.repeat) {
        return;
      }

      // Mezerník by jinak posunul stránku.
      event.preventDefault();
      header.click();
    });
  }

  ngOnDestroy(): void {
    this.unlisten?.();
  }
}
